module.exports = __webpack_public_path__ + "static/media/logo.1e5fdc16.png";